module.exports = __webpack_public_path__ + "img/helical_inner_left_gear.prt.48dbea33.jpg";